/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceStepResource } from './';
import {
    ComplianceStepResourceFromJSON,
    ComplianceStepResourceFromJSONTyped,
    ComplianceStepResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ComplianceMenuResource
 */
export interface ComplianceMenuResource {
    /**
     * 
     * @type {Array<ComplianceStepResource>}
     * @memberof ComplianceMenuResource
     */
    menu?: Array<ComplianceStepResource>;
}

/**
 * Check if a given object implements the ComplianceMenuResource interface.
 */
export function instanceOfComplianceMenuResource(value: object): value is ComplianceMenuResource {
    return true;
}

export function ComplianceMenuResourceFromJSON(json: any): ComplianceMenuResource {
    return ComplianceMenuResourceFromJSONTyped(json, false);
}

export function ComplianceMenuResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceMenuResource {
    if (json == null) {
        return json;
    }
    return {
        
        'menu': json['menu'] == null ? undefined : ((json['menu'] as Array<any>).map(ComplianceStepResourceFromJSON)),
    };
}

export function ComplianceMenuResourceToJSON(value?: ComplianceMenuResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'menu': value['menu'] == null ? undefined : ((value['menu'] as Array<any>).map((v) => ComplianceStepResourceToJSON(v))),
    };
}

